'use strict';

/**
 * @ngdoc directive
 * @name v-tv-package-channels-modal-details
 * @restrict E
 *
 * @description
 * #directive
 * A component that will show the details of a channel listed in the tv-package-channels-list directive
 *
 * @template:'<div class="multiplex-container" data-ng-class="{ \'mplex-selected\': $ctrl.isSelected, \'mplex-invalid\': $ctrl.isInvalid }"><v-tv-package-multiplex mplex="$ctrl.templateData"></v-tv-package-multiplex></div><p class="description" data-ng-bind-html="$ctrl.templateData.description"></p><p data-ng-if="$ctrl.templateData.note" class="note" data-ng-bind-html="$ctrl.templateData.note"></p>'
 * @param {object} templateData Data to pass into the scope of the modal detail box
 */
angular.module('v-tv-package').component('vTvPackageChannelsModalDetails', {
    bindings: {
        templateData: '<'
    },
    controller: function controller($scope, TvPackageSelectionStateService) {
        var _this = this;

        var cart = TvPackageSelectionStateService.getActiveCart();

        var initSelection = function initSelection() {
            _this.isSelected = cart.has(_this.templateData.id);
            _this.isInvalid = !cart.isValid(_this.templateData.id);
        };

        initSelection();

        $scope.$on('TvPackageSelectionStateService.selectionProcessed', initSelection);
    },
    template:'<div class="multiplex-container" data-ng-class="{ \'mplex-selected\': $ctrl.isSelected, \'mplex-invalid\': $ctrl.isInvalid }"><v-tv-package-multiplex mplex="$ctrl.templateData"></v-tv-package-multiplex></div><p class="description" data-ng-bind-html="$ctrl.templateData.description"></p><p data-ng-if="$ctrl.templateData.note" class="note" data-ng-bind-html="$ctrl.templateData.note"></p>'
});